import React from 'react';
import Heatmap from 'react-heatmap-grid';

const HeatmapChart = ({monthlydata}) => {

  if (monthlydata.length === 0) {
    return <div style={{ height: '500px' }}></div>;
  }
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    
  
  
        // Extract years from the data
        const years = Object.keys(monthlydata).reduce((years, date) => {
        const year = new Date(date).getFullYear();
        if (!years.includes(year)) years.push(year);
        return years;
        }, []);

        // Sort years
        years.sort();

        // Function to determine the last day of the month
            const getLastDayOfMonth = (year, month) => {
                if (month === 2) {
                // Check for leap year
                return new Date(year, 1, 29).getMonth() === 1 ? 29 : 28;
                } else if ([4, 6, 9, 11].includes(month)) {
                return 30;
                } else {
                return 31;
                }
            };

            // Generate the matrix
        const matrixData = years.map(year => {
            const rowData = [];
            for (let month = 1; month <= 12; month++) {
            const lastDayOfMonth = getLastDayOfMonth(year, month);
            const isoDateString = `${year}-${String(month).padStart(2, '0')}-${String(lastDayOfMonth).padStart(2, '0')}T00:00:00`;
            const value = monthlydata[isoDateString] !== undefined ? Number(monthlydata[isoDateString].toFixed(2)) : null;
            rowData.push(value);
            }
            return rowData;
        });
        
  

  return (
    <div style={{ fontSize: "12px", display: "flex", justifyContent: "left", alignItems: "center", height: "500px", color: "#fff" }}>
    
      <Heatmap
        xLabels={months}
        yLabels={years}
        xLabelsLocation={"bottom"}
        xLabelWidth={60}
        height={35}        
        data={matrixData}
        
        //backgroundColor={['#ffffff', '#f0f0f0', '#d9d9d9', '#a6a6a6', '#737373']}
        squares
        cellStyle={(background, value, min, max, data, x, y) => ({
            background: `rgb(0, 151, 230, ${1 - (max - value) / (max - min)})`,
            fontSize: "11.5px",
            color: "#fff"
          })}
          //cellRender={value => value && <div>{value}</div>}
          cellRender={value => value !== null ? <div>{value}</div> : <div>NA</div>}
          title={(value, unit) => `${value}`}
      />
    </div>
  );
};

export default HeatmapChart;
